import { Page } from '../../types';
import { createDefaultPages } from './page-creators/default-pages';
import { createLineCountPages } from './page-creators/line-count-pages';
import { createOneWordPages } from './page-creators/one-word-pages';
import { applyCallOutElements } from './page-creators/call-out-pages';
import { getStylesForPage } from './styles';
import { CaptionTrackMetadata } from '../../MainPlayer/types/Track/CaptionsTrack/CaptionsTrack';
import { ElementsTrack } from '../../MainPlayer/types/Track/ElementsTrack';
import { CaptionLineConfig, CAPTIONS_LINE_COUNT_MAP } from '@/domains/asset';
import { FONT_DEFAULT_VALUE } from '@/Pages/Clip/SideBar/FontSelector/constants';

export const getPagesForLineConfig = (
  args: Omit<Parameters<typeof createLineCountPages>[0], 'maxLines'> & { lineConfig: CaptionLineConfig }
) => {
  let pages: Page[] = [];
  const { lineConfig } = args;
  const maxLines = CAPTIONS_LINE_COUNT_MAP[lineConfig] as number;
  // eslint-disable-next-line no-console
  console.log({ maxLines });
  pages = createLineCountPages({
    ...args,
    maxLines
  });
  return pages;
};

export function generateCaptionPages(
  metadata: CaptionTrackMetadata,
  elementTracks: ElementsTrack[],
  fps: number,
  captionTrackOffset = 0
): Page[] {
  const { segmentWiseData, fontFamily, captionStyles, lineConfig, captionPosition, size, layout, clipStart, clipEnd } =
    metadata;
  const allPages: Page[] = [];

  const stylesForPage = getStylesForPage({
    captionStyles,
    captionPosition,
    size,
    layout,
    fontFamily: fontFamily || FONT_DEFAULT_VALUE.name
  });
  const transitions = captionStyles?.transitions;

  for (const segment of segmentWiseData) {
    const { captions, offset } = segment;
    if (!captions.length) {
      continue;
    }

    const clipDurationFrames = Math.round((clipEnd - clipStart) * fps);

    let pages: Page[] = [];

    if (lineConfig === CaptionLineConfig.OneWord) {
      pages = createOneWordPages({ captions, fps, stylesForPage, transitions });
    } else if (
      [CaptionLineConfig.OneLine, CaptionLineConfig.TwoLines, CaptionLineConfig.ThreeLines].includes(lineConfig)
    ) {
      pages = getPagesForLineConfig({
        captions,
        fontFamily,
        captionStyles,
        stylesForPage,
        fps,
        transitions,
        lineConfig,
        size
      });
    } else {
      pages = createDefaultPages({ captions, fps, stylesForPage, layout, clipDurationFrames, transitions });
    }

    if (offset > 0) {
      pages = pages.map(page => ({
        ...page,
        fromFrame: page.fromFrame + offset,
        toFrame: page.toFrame + offset,
        tokens: page.tokens.map(token => ({
          ...token,
          fromFrame: token.fromFrame + offset,
          toFrame: token.toFrame + offset
        }))
      }));
    }

    allPages.push(...applyCallOutElements(pages, elementTracks, captionTrackOffset));
  }

  return allPages;
}
